import { CommonModule } from '@angular/common';
import { Component, OnInit, input, signal } from '@angular/core';
import { Icon } from '@malirang/front-share';
import { josa } from 'es-hangul';

@Component({
  selector: 'app-empty-list',
  standalone: true,
  imports: [CommonModule, Icon],
  template: `<div
    class="flex flex-col items-center justify-center w-full col-span-4 gap-4"
    style="min-height: 640px"
  >
    <app-icon
      name="solar:clipboard-list-bold-duotone"
      class=" bg-neutral-200"
      size="xl"
    />
    <p class="text-gray-600">
      @if (title()) {
        {{ emptyMessage() }}
      } @else {
        <ng-content />
      }
    </p>
  </div> `,
})
export class EmptyListComponent implements OnInit {
  title = input<string>('');
  emptyMessage = signal<string | null>(null);

  ngOnInit() {
    this.emptyMessage.set(`등록된 ${josa(this.title(), '이/가')} 없습니다`);
  }
}
